<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <div class="member-select-pane el-input el-input--default" :class="disabled ? 'is-disabled' : ''" @click="showSelectZone">
                <span v-if="selectDepartInfo.length == 0">选择部门</span> 
                <el-tag v-else class="mx-1">
                    {{ selectDepartInfo[0].Name }}
                </el-tag>
            </div>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
        <el-dialog 
            :fullscreen="fullScreen"
            class="selectDepart"
            append-to-body
            lock-scroll
            v-model="showState" 
            title="选择部门"> 
            <template #default>
                <div class="member-select-pane member-zone">
                    <el-tag
                        v-for="depart in paneDepartInfos"
                        :key="depart.Id"
                        class="mx-1"
                        closable
                        @close="deleteDepart(depart)">
                        {{ depart.Name }}
                    </el-tag>
                </div>
                <el-scrollbar height="270px">
                    <tree :options="options" v-model="treeValue">
                    </tree>
                </el-scrollbar>
                <div class="depart-select-footer">
                    <el-button @click="showState = false">取消</el-button>
                    <el-button type="primary" @click="sumbit">确认</el-button>
                </div>
            </template>
        </el-dialog>
    </el-col>
</template>

<style>
    .member-select-pane{
        cursor:pointer;
        border: 1px dashed #dcdfe6;
        border-radius: 4px;
        color:#606266;
        padding: 8px 10px;
        line-height: 24px;
    }
    .selectDepart .el-dialog__body{
        padding-top:15px;
        border-top: 1px rgb(164, 168, 176) solid;
    }
    .member-zone{
        height:35px;
        line-height: 32px;
    }
</style>
    
<script>
    import baseSingleDepartField from './BaseSingleDepartField'
    import Tree from '../../Tree/Tree.vue'
    import { Close } from "@element-plus/icons-vue";

    export default {
        name:"SingleDepartField",
        mixins:[baseSingleDepartField],
        components:{
            'tree':Tree,
            'close':Close
        },
        data:function(){
            return {
                treeValue:null
            }
        },
        computed:{
            selectDepartInfo:function(){
                return this.departList.filter(x=>x.Id == this.data[this.name]);
            },

            paneDepartInfos:function(){
                return this.departList.filter(x=>x.Id == this.treeValue);
            }
        },
        methods:{
            showSelectZone:function(){
                if(this.disabled || this.forceDisplay){
                    return;
                }
                this.treeValue = this.data[this.name];
                if(this.reComputedOptions){
                    this.changeOptions();
                    this.reComputedOptions = false;
                }
                this.showState = true;
            },
            sumbit:function(){
                this.data[this.name] = this.treeValue;
                this.showState = false
            },
            deleteDepart:function(depart){
                this.treeValue = null;
            }
        }
    }
</script>